
export default function StatusComponent() {
    return <div>My Custom Component</div>;
  }